import type { Dispatch, AnyAction } from 'redux';

import * as FieldReportAssignmentHistoryAPI from 'ab-api/web/fieldReportAssignmentHistory/findForFieldReport';
import type { W_FieldReportAssignmentHistory_FindForFieldReport_VM } from 'ab-api/web/fieldReportAssignmentHistory/findForFieldReport/viewModel';

import type { GetRootState } from 'af-reducers';

import { errorHandler } from 'af-utils/actions.util';
import { http } from 'af-utils/http.util';

export function findAssignmentHistoryForFieldReport(workOrderId: number) {
	return async (dispatch: Dispatch<AnyAction>, getState: GetRootState, { redirectTo }) => {
		const action = async () => {
			return await http.get<W_FieldReportAssignmentHistory_FindForFieldReport_VM[]>(FieldReportAssignmentHistoryAPI.URL(workOrderId));
		};
		return await errorHandler(action, dispatch, redirectTo);
	};
}
